export default __webpack_public_path__ + "static/media/633.a8f8bb9d.gif";